import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  container: {
    backgroundColor: Colors.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '1.5rem',
    fontSize: '1rem',
    gap: '1rem',
    boxShadow: '0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    borderRadius: '5px',
    width: 'calc(33% - 1.8rem)',
  },
  title: {
    textAlign: 'center',
    fontSize: '2rem',
  },
  graphContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  graphWrapper: {
    display: 'flex',
    flexDirection: 'flex-start',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '75%',
  },
}))

export default styles
